export default {
    mixed: {
        default: 'No es válido',
        required: '${path} es un campo requerido',
        notType: ({ path, type, value, originalValue }) => {
            let isCast = originalValue != null && originalValue !== value;
            let msg = `${path} debe ser del tipo \`${type}\``;
            //Return
            return msg;
        },
        /*oneOf: params => {
            const { path, type, value, values} = params;
            let msg = `${path} debe coincidir con alguno de los valores de ${values}`;
            //Return
            return msg;
        }*/
    },
    string: {
        required: '${path} es un campo requerido',
        min: ({ path, min}) => (`Debe tener al menos ${min} caraceres`)
    },
    number: {
        default: 'Debe ingresar un valor numérico',
        required: '${path} es un campo requerido'
    }
}